import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useBackendStatus } from '../../context/BackendStatusContext';

const { FiAlertTriangle, FiRefreshCw, FiX } = FiIcons;

const BackendStatusBanner = () => {
  const { isConnected, isChecking, hasCheckedOnce, checkNow, dismissed, setDismissed } = useBackendStatus();

  const show = hasCheckedOnce && !isConnected && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="backend-status-banner"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeInOut' }}
          className="w-full bg-red-600 text-white overflow-hidden z-[150] relative"
          role="alert"
          aria-live="polite"
        >
          <div className="container mx-auto px-4 py-3 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <SafeIcon icon={FiAlertTriangle} className="w-5 h-5 flex-shrink-0 text-red-200" />
              <div className="min-w-0">
                <p className="text-sm font-bold leading-snug">
                  Backend Connection Unavailable
                </p>
                <p className="text-xs text-red-100 leading-snug mt-0.5">
                  Some features may not work.
                  <span className="hidden sm:inline"> Verify your NoCodeBackend token and proxy URL in </span>
                  <span className="sm:hidden"> Check </span>
                  <strong className="text-white">Settings → Integrations</strong>
                  <span className="hidden sm:inline">, then retry.</span>
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 flex-shrink-0">
              <button
                onClick={checkNow}
                disabled={isChecking}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-white/15 hover:bg-white/25 disabled:hover:bg-white/15 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors disabled:opacity-50"
              >
                <SafeIcon icon={FiRefreshCw} className={`w-3.5 h-3.5 ${isChecking ? 'animate-spin' : ''}`} />
                {isChecking ? 'Checking…' : 'Retry'}
              </button>

              <button
                onClick={() => setDismissed(true)}
                aria-label="Dismiss backend status warning"
                className="p-1.5 hover:bg-white/15 rounded-lg transition-colors text-white/70 hover:text-white"
              >
                <SafeIcon icon={FiX} className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BackendStatusBanner;